import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { routeSettings } from 'src/app/core/routes.config';
import { UsersState } from 'src/app/features/users/state/users.state';
import { PrefillDataState } from 'src/app/shared/states/prefill-data/prefill-data.state';
import { DispatchDashboardAuthService } from '../services/dispatch-dashboard-auth.service';

export const dispatchDashboardAuthGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);
  const authService = inject(DispatchDashboardAuthService);
  const platformId = inject(PLATFORM_ID);

  const loginPath = `/${routeSettings.dispatchDashboard.path}/login`;

  const loginRequired = store.selectSnapshot(PrefillDataState.dispatchDashboardLoginRequired);
  if (!loginRequired) {
    return true;
  }

  const regularToken = store.selectSnapshot(UsersState.auth)?.access_token ?? null;
  if (regularToken) {
    return true;
  }

  if (!isPlatformBrowser(platformId)) {
    return router.parseUrl(loginPath);
  }

  const session = authService.getSession();
  if (!session?.token) {
    return router.parseUrl(loginPath);
  }

  return authService.validateToken(session.token).pipe(
    map((isValid) => {
      if (isValid) {
        return true;
      }
      authService.clearSession();
      return router.parseUrl(loginPath);
    }),
    catchError(() => {
      authService.clearSession();
      return of(router.parseUrl(loginPath));
    })
  );
};
